<template>

      <div class="flex-row name-wrapper">
        <div
          v-if="!editName"
          class="name pointer"
          @click="goToChecklistDetailsPage"

        >
          {{ checklist.name }}
        </div>
        <div class="inputBox" v-if="editName" >
          <form @submit.prevent="handleNameChange">
            <input type="text" v-model="checklist.name" :ref="index" autofocus/>
          </form>
          <button v-if="!loader" @click="closeEditChecklistName"><i class="far fa-times-circle"></i></button>
          <b-spinner
            v-if="loader"
            style="float: right; margin-right: 5px"
            small
            label="Loading..."
          ></b-spinner>
        </div>
        <div v-if="!editName" class="editChecklistNameButton pointer" @click="toggleEditChecklistName">
          <i class="far fa-edit"></i>
        </div>
        <div class="date">
          {{
            moment(checklist.created).format(
              "MM-DD-YYYY hh:mm A"
            )
          }}
        </div>
      </div>
  
</template>
<script>
import moment from 'moment';
import api from '../axios_api';
export default {
  name: "checklist-name",
  props: ["checklist", "currentCompany", "isDetails", "index"],
  data(){
    return{
      moment: moment,
      editName: false,
      checklistName: "",
      loader: false
    }
  },
  watch:{
    
  },
  methods: {
    // handleFocusOut(){
    //   this.editName = false;
    // },
    goToChecklistDetailsPage(){
      if(!this.isDetails){
        this.handleChecklistNameClick(this.checklist)
      }
    },
    handleChecklistNameClick(checklist) {
      let self = this;
      self.$router.push(
        `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/checklist/${self.currentCompany._id}/${self.$route.params.ucid}/${this.checklist._id}`
      );
    },
    toggleEditChecklistName(){
      this.checklistName = this.checklist.name;
      this.editName = !this.editName;
    },
    closeEditChecklistName(){
      this.editName = !this.editName;
      this.checklist.name = this.checklistName;
    },
    handleNameChange(){
      if(this.checklist.name.length > 0){
        this.handleUpdateChecklist();
      }
    },
    async handleUpdateChecklist() {
      let self = this;
      
      this.loader= true

      try {
        await api.put(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/${self.$route.params.portfolio_item}/checklist/${self.checklist._id}`,
          {
            encrypt: {
              data: {
                name: this.checklist.name
              }
            }
          }
        );
        this.editName = false;
        this.loader= false;
        this.$emit("refresh");
      } catch (e) {
        console.log("error: ", e);
        this.editName = false;
        this.loader= false;
        this.checklist.name = this.checklistName;
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.editChecklistNameButton{
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.name-wrapper {
      margin: 10px 0 5px 0;

      .name {
        text-align: left;
        font-size: 14px;
        line-height: 1.5;
        letter-spacing: 0px;
        color: #000000;
        opacity: 1;
        margin-right: 8px;
      }
      .date {
        text-align: left;
        font-size: 12px;
        line-height: 1.5;
        letter-spacing: 0px;
        color: #00000080;
        opacity: 1;
      }
    }
    .inputBox{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      border: 1.5px solid #000000;
      border-radius: 5px;
      input{
        min-width: 180px;
        font-size: 12px;
        padding: 5px;
        border: none;
        outline: none;
        background: none;
      }
      button{
        background: none;
        border: none;
      }
    }
</style>